import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App.jsx'
import './styles/index.css'

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

const httpLink = new HttpLink({
  uri: `${import.meta.env.VITE_API_BASE_URL}/graphql`,
  credentials: 'include'
})

const authLink = setContext((_, { headers }) => {
  // Prefer persisted token, fallback to in-memory session token (set when "Remember me" is off)
  const token = (typeof window !== 'undefined' && (
    window.__SESSION_TOKEN__ ||
    window.__PROFILE_TOKEN__ ||
    sessionStorage.getItem('authToken') ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken')
  )) || null

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const apolloClient = new ApolloClient({
  ssrMode: typeof window === 'undefined',
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache()
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
)
